import * as React from "react";
import { Product } from "../../../models";

export interface ProductCarouselItemProps extends Product {}

const altName = (product: Product) => `${product.code}-${product.name}`;

const ProductCarouselItem = (props: ProductCarouselItemProps): JSX.Element => (
  <div
    className="product-carousel__item"
    title={altName(props)}
    style={{ backgroundImage: `url(${props.image})` }}
  >
    <div className="product-carousel__item__info">
      <h1 className="product-carousel__item__title">{props.name}</h1>
      <div className="product-carousel__item__price">
        <span>{props.display_price}</span>
      </div>
      <p className="product-carousel__item__subtitle">
        <span>
          Kích thước<br />
          {props.display_dimension}
        </span>
      </p>
      <p className="product-carousel__item__subtitle">
        <span>
          Thời gian<br />
          {props.display_time}
        </span>
      </p>
      <p className="product-carousel__item__subtitle">
        <span>
          Tư vấn<br />
          {props.display_consultant}
        </span>
      </p>
      <p className="product-carousel__item__subtitle">
        <span>
          Sản phẩm<br />
          {props.display_deliverable}
        </span>
      </p>
    </div>
  </div>
);

export default ProductCarouselItem;



// WEBPACK FOOTER //
// ./src/routes/ProductCarousel/components/ProductCarouselItem.tsx